import {
  clearSrDocumentLocationAction,
  deleteSrDocumentLocation,
} from 'actions/srDocuments/srDocumentLocationActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const SrDocumentLocationDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentLocationAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteSrDocumentLocation(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this site readiness document location?
        This can not be undone.
      </div>
    </form>
  )
}

export default SrDocumentLocationDelete
